import { useTranslation } from 'react-i18next'

export const lateNightGreetings = ['greetings.late_night.magic', 'greetings.late_night.productive']

export const earlyMorningGreetings = [
  'greetings.early_morning.special',
  'greetings.early_morning.good',
  'greetings.early_morning.fresh',
  'greetings.early_morning.rise',
  'greetings.early_morning.new_day',
  'greetings.early_morning.opportunities',
  'greetings.early_morning.morning',
  'greetings.early_morning.possibilities',
  'greetings.early_morning.make_it'
]

export const lateMorningGreetings = [
  'greetings.late_morning.morning',
  'greetings.late_morning.vibes',
  'greetings.late_morning.hey'
]

export const earlyAfternoonGreetings = [
  'greetings.early_afternoon.good',
  'greetings.early_afternoon.great_day',
  'greetings.early_afternoon.afternoon'
]

export const lateAfternoonGreetings = [
  'greetings.late_afternoon.welcome',
  'greetings.late_afternoon.keep_going'
]

// export const twilightGreetings = [
//   "🌆 Evening is near!",
//   "🌒 Dusk is beautiful!"
// ]

export const nightGreetings = [
  'greetings.night.good',
  'greetings.night.evening',
  'greetings.night.welcome',
  'greetings.night.good_evening'
]

// Original 'new' greetings retained with enthusiasm
export const newMorningGreetings = [
  'greetings.new_morning.achieve',
  'greetings.new_morning.limitless',
  'greetings.new_morning.fresh',
  'greetings.new_morning.success',
  'greetings.new_morning.dream',
  'greetings.new_morning.brilliance',
  'greetings.new_morning.moments',
  'greetings.new_morning.make_it',
  'greetings.new_morning.magic',
  'greetings.new_morning.shine'
]

export const newAfternoonGreetings = [
  'greetings.new_afternoon.unstoppable',
  'greetings.new_afternoon.focus',
  'greetings.new_afternoon.creativity',
  'greetings.new_afternoon.goals',
  'greetings.new_afternoon.potential',
  'greetings.new_afternoon.ideas',
  'greetings.new_afternoon.energy',
  'greetings.new_afternoon.vision',
  'greetings.new_afternoon.no_limits',
  'greetings.new_afternoon.strength',
  'greetings.new_afternoon.dreams',
  'greetings.new_afternoon.inspiration'
]

export const newEveningGreetings = [
  'greetings.new_evening.wisdom',
  'greetings.new_evening.dreams',
  'greetings.new_evening.inspiration',
  'greetings.new_evening.vision',
  'greetings.new_evening.possibilities',
  'greetings.new_evening.ideas',
  'greetings.new_evening.journey',
  'greetings.new_evening.brilliance',
  'greetings.new_evening.reality',
  'greetings.new_evening.momentum'
]

export const getTimeBasedGreeting = (
  isNewChat: boolean = false,
  t: (key: string) => string = (key: string) => key
): string => {
  const hour = new Date().getHours()
  const dayOfYear = Math.floor(
    (Date.now() - new Date(new Date().getFullYear(), 0, 0).getTime()) / 86400000
  )

  let greetings: string[]
  if (hour >= 0 && hour < 6) {
    greetings = isNewChat ? newEveningGreetings : lateNightGreetings
  } else if (hour >= 6 && hour < 9) {
    greetings = isNewChat ? newMorningGreetings : earlyMorningGreetings
  } else if (hour >= 9 && hour < 12) {
    greetings = isNewChat ? newMorningGreetings : lateMorningGreetings
  } else if (hour >= 12 && hour < 17) {
    greetings = isNewChat ? newAfternoonGreetings : earlyAfternoonGreetings
  } else if (hour >= 17 && hour < 19.5) {
    greetings = isNewChat ? newAfternoonGreetings : lateAfternoonGreetings
  } else {
    greetings = isNewChat ? newEveningGreetings : nightGreetings
  }

  // Use a deterministic approach based on day and hour instead of random
  const seed = dayOfYear + hour + (isNewChat ? 1000 : 0)
  const index = seed % greetings.length

  return t(greetings[index])
}

// Keep the shuffle function for other potential uses, but make it deterministic with seed
const shuffleArrayWithSeed = (array: string[], seed: number) => {
  const shuffled = [...array] // Create a copy to avoid mutating original array

  // Simple seeded pseudo-random number generator
  let currentSeed = seed
  const seededRandom = () => {
    currentSeed = (currentSeed * 9301 + 49297) % 233280
    return currentSeed / 233280
  }

  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(seededRandom() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled
}

// Keep the original shuffle function for backward compatibility
const shuffleArray = (array: string[]) => {
  const shuffled = [...array] // Create a copy to avoid mutating original array
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled
}
